// extracted by mini-css-extract-plugin
export default {"componentWrapper":"WorkInProgress_componentWrapper__kq3nI"};